import React, { useContext } from 'react';

import { BriefingContext } from '../../../../containers/campanhas/Briefing';
import BriefingLogos from '../../../../containers/campanhas/Logo/Briefing';
import { BriefingTitleRow } from '../index';

const Resume = () => {
	const {
		campaign,
	} = useContext(BriefingContext);

	return (
		<>
			<BriefingTitleRow>Selecione o logo que será usado em sua campanha:</BriefingTitleRow>
			<div className="row mb-1">
				<div className="col-12">
					<BriefingLogos
						idLogo={campaign.idLogo}
						setIdLogo={campaign.setIdLogo}
						setNameLogo={campaign.setNameLogo}
						buttonMargin="0 0 20px"
					/>
				</div>
			</div>
		</>
	);
};
export default Resume;
